 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTML00_COVER from '@/components/xhtml/00_Cover'
 import XHTML04_COPYRIGH from '@/components/xhtml/04_Copyrigh'
 import XHTML03_TITLE_PA from '@/components/xhtml/03_Title_pa'
 import XHTML02_FRONT_MA from '@/components/xhtml/02_Front_ma'
 import XHTML05_CONTENTS from '@/components/xhtml/05_Contents'
 import XHTML06_PREFACE from '@/components/xhtml/06_Preface'
 import XHTML07_1_OLD_QU from '@/components/xhtml/07_1_Old_Qu'
 import XHTML08_2_THE_AC from '@/components/xhtml/08_2_The_Ac'
 import XHTML09_3_THE_TH from '@/components/xhtml/09_3_The_Th'
 import XHTML10_4_THE_HU from '@/components/xhtml/10_4_The_Hu'
 import XHTML11_5_PROFES from '@/components/xhtml/11_5_Profes'
 import XHTML12_6_MORE_T from '@/components/xhtml/12_6_More_T'
 import XHTML13_7_COSMIC from '@/components/xhtml/13_7_Cosmic'
 import XHTML14_8_THE_FI from '@/components/xhtml/14_8_The_Fi'
 import XHTML15_9_NATURE from '@/components/xhtml/15_9_Nature'
 import XHTML16_10_ON_TH from '@/components/xhtml/16_10_On_th'
 import XHTML17_11_THE_L from '@/components/xhtml/17_11_The_L'
 import XHTML18_12_CHASI from '@/components/xhtml/18_12_Chasi'
 import XHTML19_13_PROFE from '@/components/xhtml/19_13_Profe'
 import XHTML20_CAST_OF from '@/components/xhtml/20_Cast_of'
 import XHTML21_NOTES from '@/components/xhtml/21_Notes'
 import XHTML22_BIBLIOGR from '@/components/xhtml/22_Bibliogr'
 import XHTML23_IMAGE_CR from '@/components/xhtml/23_Image_Cr'
 import XHTML24_INDEX from '@/components/xhtml/24_Index'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/05_Contents",
 			"name" : "xhtml/05_Contents",
 			"component" : XHTML05_CONTENTS
 		},
 		{
 			"path" : "/xhtml/06_Preface",
 			"name" : "xhtml/06_Preface",
 			"component" : XHTML06_PREFACE
 		},
 		{
 			"path" : "/xhtml/07_1_Old_Qu",
 			"name" : "xhtml/07_1_Old_Qu",
 			"component" : XHTML07_1_OLD_QU
 		},
 		{
 			"path" : "/xhtml/08_2_The_Ac",
 			"name" : "xhtml/08_2_The_Ac",
 			"component" : XHTML08_2_THE_AC
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js